import { App } from "antd";
import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setDefaultClientStep } from "store/user/(default)/client/default_client.action";
import { defaultClientStepSelector } from "store/user/(default)/client/default_client.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useStep = () => {
  const { message } = App.useApp();
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const step = useSelector(defaultClientStepSelector);
  // -------------------------- FUNCTION ------------------------
  const handlePrev = useCallback(() => {
    if (step === 0) return;
    const prev = step - 1;
    dispatch(setDefaultClientStep(prev));
  }, [dispatch, step]);

  const handleNext = useCallback(() => {
    if (step >= 4) return;
    const next = step + 1;
    dispatch(setDefaultClientStep(next));
  }, [dispatch, step]);

  // :::::::: contact :::::::::://
  const handleContact = (form) => {
    form
      ?.validateFields()
      .then((values) => {
        if (!values)
          return message.error("Invalid Error! Vui lòng kiểm tra lại sau");
        const { email, phone, address } = values;
        form?.setFieldValue("contact", { email, phone, address });
        handleNext();
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  // :::::::: basic :::::::::://
  const handleBasic = (form) => {
    form
      ?.validateFields()
      .then((values) => {
        if (!values)
          return message.error("Invalid Error! Vui lòng kiểm tra lại sau");
        const {
          legalName,
          businessRegistrationNumber,
          businessType,
          businessField,
          legalAddress,
        } = values;
        form?.setFieldValue("basic", {
          legalName,
          businessRegistrationNumber,
          businessType,
          businessField,
          legalAddress,
        });
        handleNext();
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  // :::::::: finance :::::::::://
  const handleFinance = (form) => {
    form
      ?.validateFields()
      .then((values) => {
        if (!values)
          return message.error("Invalid Error! Vui lòng kiểm tra lại sau");
        const { bankAccount } = values;
        form?.setFieldValue("finance", {
          bankAccount,
        });
        handleNext();
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  // :::::::: kyb :::::::::://
  const handleKYB = (form) => {
    form
      ?.validateFields()
      .then((values) => {
        if (!values)
          return message.error("Invalid Error! Vui lòng kiểm tra lại sau");
        const {
          legalRepresentName,
          legalRepresentDob,
          legalRepresentAddress,
          identifyCard,
          docFront,
          docBack,
        } = values;
        if (docFront === "")
          return message.info("Làm ơn tải CCCD/CMND mặt trước");
        if (docBack === "") return message.info("Làm ơn tải CCCD/CMND mặt sau");

        form?.setFieldValue("kyb", {
          legalRepresentName,
          legalRepresentDob,
          legalRepresentAddress,
          identifyCard,
          docFront,
          docBack,
        });
        handleNext();
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  // :::::::: complete :::::::::://
  const handleComplete = (form) => {
    form
      ?.validateFields()
      .then((values) => {
        if (!values)
          return message.error("Invalid Error! Vui lòng kiểm tra lại sau");

        const { document } = values;
        if (document === "")
          return message.info(
            "Vui lòng tải ảnh tài liệu pháp lý trước khi gửi hồ sơ !"
          );

        console.log({ values });
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    handlePrev,
    handleNext,
    handleContact,
    handleBasic,
    handleFinance,
    handleKYB,
    handleComplete,
  };
};
